import React, {
  ButtonHTMLAttributes,
  FC,
  Fragment,
  ReactNode,
  SetStateAction,
  useState,
  Dispatch,
} from 'react';
import { Menu, Transition } from '@headlessui/react';
import { CaretDown } from '..';

export interface DropdownProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  items?: string[];
  setSelectedItem?: Dispatch<SetStateAction<string>>;
  type?: 'button' | 'submit' | 'reset' | undefined;
}

const { Button, Items, Item } = Menu;

const SCDropDownStyle = `px-4 py-1.75 min-w-[110px] flex flex-grow justify-between items-center 
bg-thryv-gray-light-300 text-btn-text rounded-3px text-thryv-black-400 font-open-sans font-normal 
capitalize hover:bg-thryv-gray-medium-200 active:bg-thryv-orange-500 active:text-white focus-visible:ring-opacity-75 border 
border-thryv-gray-light-300 hover:border-thryv-gray-medium-200`;

export const DropdownButton: FC<DropdownProps> = ({
  children,
  className,
  items = [],
  setSelectedItem,
  type = 'button',
  ...rest
}: DropdownProps): JSX.Element => {
  const [selected, setSelected] = useState<string>('');

  const handleOnclick = (item: string): void => {
    if (!selected.includes(item)) {
      setSelected(item);
    }
  };

  return (
    <div className={`max-w-[199px] text-right ${className && className}`}>
      <Menu as="div" className="text-left">
        <Button className={SCDropDownStyle} {...rest}>
          {children}
          <CaretDown className={`fill-current ml-2`} />
        </Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="transform opacity-0"
          enterTo="transform opacity-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100"
          leaveTo="transform opacity-0"
        >
          <Items className="max-w-[199px] w-full mt-3 origin-top-right bg-white rounded shadow-thryv focus:outline-none overflow-hidden absolute">
            <>
              {items.map((item, i) => (
                <div key={i}>
                  <Item>
                    {({ active }) => (
                      <button
                        type={type}
                        className={`${
                          active &&
                          'bg-thryv-white-300 transition-all duration-300'
                        } group flex items-center w-full px-2 py-2 text-[12px] font-open-sans capitalize`}
                        onClick={() => {
                          handleOnclick(item);
                          if (setSelectedItem) {
                            setSelectedItem(item);
                          }
                        }}
                      >
                        {item}
                      </button>
                    )}
                  </Item>
                </div>
              ))}
            </>
          </Items>
        </Transition>
      </Menu>
    </div>
  );
};
